// Fence Works app entry. The import order below is load-bearing: it mirrors
// the script-tag order of the old build-less shell ("Fence Works.html"), where
// each file published globals consumed by the ones after it.

// 0. crash reporting first, so an error thrown while the rest loads is caught
//    too (lib/crash.ts: listens for uncaught errors + unhandled rejections)
import "./lib/crash";
import { CrashBoundary } from "./lib/crashcard";

// 1. engine + data libs (publish window.VFP, VFP_CODES, VFP_SPECS, VFP_PARCEL, VFP_SLOPE)
import "./lib/engine";
import "./lib/codes";
import "./lib/specs";
import "./lib/parcel";
import "./lib/slope";
import "./lib/buildings";
// 1b. demo mode decides at boot (from the URL) whether this tab is the
//     sandbox — must run before the cloud sync module and every screen
import "./lib/demo";
// 2. Supabase cloud sync (publishes window.VFP_DB)
import "./lib/supabase";

// 3. styles (same cascade order as the old <link> tags)
import "./styles.css";
import "./screens.css";

// 4. screens — the registry initializes every screen module in legacy order
import { Root } from "./registry";

import { createRoot } from "react-dom/client";

// a render crash outside any page's own boundary gets a "reload" card, not a white screen
createRoot(document.getElementById("root")!).render(<CrashBoundary><Root /></CrashBoundary>);

// PWA field mode: register the service worker (prod builds only — dev server
// module URLs would poison the cache). Cached shell = the app opens offline
// in the truck; data comes from the local store and syncs when back online.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
